module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "insurerElement",
    staticClass: "row resultado grey-top-border with-spacing-top no-margin",
    attrs: {
      "insurer": 'result-' + _vm.additional.company.name
    }
  }, [_c('span', {
    ref: "popupMessage",
    staticClass: "popup_message"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-2 small-x-padding"
  }, [(_vm.showOffer) ? _c('img', {
    staticClass: "oferta",
    attrs: {
      "src": "images/ofertas.png"
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "insurer-badge",
    class: {
      'open-insurer': _vm.insurerAccess
    },
    attrs: {
      "data-insurer-id": _vm.additional.company.id,
      "data-insurer-badge": _vm.additional.company.name,
      "src": (_vm.imagesPath || 'images/login-insurers') + '/' + _vm.additional.company.name + '.png',
      "title": _vm.additional.company.name
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.additional.company.name))])]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-md-1 margin-top-15 hidden-xs hidden-sm small-x-padding"
  }, [_vm._v("\n       " + _vm._s(_vm.quotationResult.time) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-md-2 text-left hidden-xs hidden-sm small-x-padding"
  }, [_c('div', {
    staticClass: "product"
  }, [_vm._v(_vm._s(_vm.quotationResult.product))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-2 margin-top-15 text-center small-x-padding"
  }, [_c('a', {
    staticClass: "amazing-tooltip"
  }, [_c('div', {
    staticClass: "in-cash"
  }, [_vm._v(_vm._s(_vm.numberBrazilianPattern(_vm.quotationResult.premium, 2)))]), _vm._v(" "), _c('span', {
    staticClass: "forward hidden-xs hidden-sm"
  }, _vm._l((_vm.quotationResult.installments), function(payments, paymentType) {
    return _c('div', {
      key: paymentType,
      staticClass: "payments"
    }, [_c('h5', [_vm._v(_vm._s(_vm.paymentTypesPreDefinition[paymentType] || paymentType))]), _vm._v(" "), _vm._l((payments), function(value, key) {
      return _c('div', {
        key: key
      }, [_vm._v("\n                        " + _vm._s(key) + " - R$ " + _vm._s(value) + "\n                    ")])
    })], 2)
  }))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "col-xs-10 col-xs-offset-1 col-sm-3 small-x-padding"
  }, [_c('div', [(_vm.insurerAccess) ? _c('button', {
    staticClass: "btn btn-primary no-margin open-residence-quotation hidden-xs hidden-sm",
    attrs: {
      "data-preco-id": _vm.quotationResult.priceId,
      "type": "button",
      "disabled": ""
    }
  }, [_vm._m(1, false, false)]) : _vm._e(), _vm._v(" "), (_vm.insurerAccess) ? _c('button', {
    staticClass: "btn btn-primary btn-block btn-xs no-margin open-residence-quotation visible-xs-block visible-sm-block",
    attrs: {
      "data-preco-id": _vm.quotationResult.priceId,
      "type": "button",
      "onclick": "location.href=javascript:void(0)"
    }
  }, [_vm._m(2, false, false)]) : _vm._e()]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-link no-padding-sides hidden-xs hidden-sm no-margin",
    attrs: {
      "type": "button",
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        _vm.showQuotationModalInsurerResult = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" Detalhes da cotação\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link no-padding-sides no-margin visible-xs-block visible-sm-block",
    attrs: {
      "type": "button",
      "data-toggle": "modal"
    },
    on: {
      "click": _vm.showQuotationModalInsurerResult
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" Detalhes\n            ")])]), _vm._v(" "), _c('div', [(_vm.isPDFValid()) ? _c('a', {
    ref: 'pdf-' + _vm.quotationResult.priceId,
    staticClass: "btn btn-link no-padding no-margin hidden-xs hidden-sm",
    attrs: {
      "id": 'pdf-' + _vm.quotationResult.priceId,
      "href": _vm.quotationResult.pdf,
      "target": "_blank"
    }
  }, [_vm._m(3, false, false)]) : _vm._e()])]), _vm._v(" "), (_vm.showQuotationModalInsurerResult) ? _c('partial-modal-result-insurer-details', {
    attrs: {
      "imagesPath": _vm.imagesPath,
      "insurer": _vm.additional.company,
      "quotationResult": _vm.quotationResult
    },
    on: {
      "close": function($event) {
        _vm.showQuotationModalInsurerResult = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3 col-sm-2 col-md-1 margin-top-15 small-x-padding"
  }, [_c('div', {
    staticClass: "produto-adicional",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("PRODUTO"), _c('br'), _vm._v("ADICIONAL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v("\n                    Abrir na seguradora\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v("\n                    Abrir\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" PDF da cotação\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36d532a3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/enterprise/modules/Result/PartialInsurerAdditionalProduct.vue
// module id = 337
// module chunks = 0